import * as React from 'react';
import { ReactNode } from 'react';
import err404 from '../../BaseLayout/assets/img/error/error-404.svg';

interface Props {
  code?: number;
  message?: string;
}

export const ErrorComponent = (props: Props): ReactNode => {
  const getContent = (code: number): ReactNode => {
    if (!code) {
      return;
    }
    switch (true) {
      case code >= 500:
        return <></>;
      case code === 404:
        return <img src={err404} alt={'error 404 not found'}/>;
      case code >= 400:
        return <></>;
      case code >= 300:
        return <></>;
      default:
        return <></>;
    }
  };

  return <div>
    {getContent(props.code)}
  </div>;
};
